import { Bubble, Conversations, Prompts, PromptsProps, Sender, useXAgent, useXChat, Welcome } from '@ant-design/x';
import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import { cloneDeep } from 'lodash';
import { CheckCircleOutlined, GlobalOutlined, RightOutlined, SyncOutlined } from '@ant-design/icons';
import { Collapse, CollapseProps, Dropdown, type GetProp, MenuProps, message as Toast, Modal, Radio, Select, Space, Typography } from 'antd';
import { AuthCheck } from '../../../layout/enaea/AuthCheck';
import { useTranslation } from 'react-i18next';
import markdownIt from 'markdown-it';
import { useRootSelector } from '../../../hooks';
import { AbilityTypeId, baseUrl, ChatRequestBody, ChatResp, EventType, ModelItemType, ModelType, ModelTypeID, URL } from '../../../api';
import { Allow, parse } from 'partial-json';
import _ from 'underscore';
import './index.scss';
import { Markdown } from '../../../components';
import { DefaultQuestions } from '../../../utils/defaultQuestions';
import Avatar from '../../../assets/images/avatar.webp';
import AILogo from '../../../assets/images/ai-logo.webp';
import AIAvatar from '../../../assets/images/ai-avatar.webp';
import AIChatAvatar from '../../../assets/images/ai-chat-acatar.webp';
import DefaultExpert from '../../../assets/images/default-expert.webp';
import DefaultSource from '../../../assets/images/default-source.webp';
import { getValueByProp } from '../../../utils/cu';
const description: any = {
    [ModelType.COMMON]: '欢迎来到"中国教育干部网络学院"，以AI之力赋能教育干部成长。',
    [ModelType.RESOURCE]: '欢迎来到"中国教育干部网络学院"，输入关键词，帮您精准推荐课程与数字馆藏。',
    [ModelType.ASSISTANT]: '欢迎来到"中国教育干部网络学院"，在平台有任何操作问题都可以随时咨询我!',
    [ModelType.PROJECT]: '欢迎来到"中国教育干部网络学院"，输入您的培训需求，帮您精准推荐相关项目。',
    [ModelType.PARTNER]: '欢迎来到“智能学伴”，在这里我可以帮你进行项目查询、课程查询、作业查询以及个人培训情况查询，快来试试吧~',
    [ModelType.NO_AUTH]: `您可以输入“${URL.login}”并点击左下角的【登录按钮】`
};
const placeholderPromptsItems: any = DefaultQuestions;
const CatAIIcon = (
    <span className={'welcome-icon'}>
        <img src={AIChatAvatar} alt={'ai'} />
    </span>
);
const roles: GetProp<typeof Bubble.List, 'roles'> = {
    ai: {
        placement: 'start',
        avatar: {
            icon: CatAIIcon
        },
        styles: {
            content: {
                borderRadius: 16
            }
        }
    },
    local: {
        avatar: {
            icon: <img src={Avatar} alt={''} />
        },
        placement: 'end',
        variant: 'borderless',
        footer: null
    }
};
type PromptsType = {
    id?: string;
    message?: string;
};
const { confirm } = Modal;
const Chats: React.FC = () => {
    const { t } = useTranslation();
    const md = markdownIt({ html: true, breaks: true });
    const userInfo = useRootSelector((state) => state.enaea?.userinfo);
    const defaultConversationsItems = localStorage.getItem('conversation-list') || JSON.stringify([]);
    const conversationsItemsList = JSON.parse(defaultConversationsItems);
    const defaultConversationsItem = {
        key: String(Math.floor(Math.random() * 1024)),
        id: '',
        conversation_id: '',
        label: t('newConversation'),
        type: ModelType.COMMON,
        typeId: ModelTypeID.COMMON,
        senderPromptsItems: [],
        message: []
    };
    const [content, setContent] = React.useState('');
    const [conversationsItems, setConversationsItems] = React.useState(conversationsItemsList);
    const [currentConversation, setCurrentConversation] = useState<typeof defaultConversationsItem>(cloneDeep(defaultConversationsItem));
    const [activeKey, setActiveKey] = React.useState<string | undefined>('');
    const [prompts, setPrompts] = useState<PromptsType | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [currentMsg, setCurrentMsg] = useState({
        message: '',
        status: '',
        id: '',
        message_id: '',
        conversation_id: '',
        conversation_key: '',
        type: ''
    });
    const [modelType, setModelType] = useState<ModelType>(ModelType.COMMON);
    const [onlineSearch, setOnlineSearch] = useState<string>('');
    const [isFirst, setIsFirst] = useState<boolean>(true);
    const modelList: ModelItemType[] = [
        {
            id: ModelTypeID.COMMON,
            key: ModelTypeID.COMMON,
            message: t('modelType.common'),
            class: 'iconfont icon-tongyongfuwu',
            type: ModelType.COMMON
        },
        {
            id: ModelTypeID.RESOURCE,
            key: ModelTypeID.RESOURCE,
            message: t('modelType.resource'),
            class: 'iconfont icon-agent-resource',
            type: ModelType.RESOURCE
        },
        {
            id: ModelTypeID.ASSISTANT,
            key: ModelTypeID.ASSISTANT,
            message: t('modelType.assistant'),
            class: 'iconfont icon-zixundayi',
            type: ModelType.ASSISTANT
        },
        {
            id: ModelTypeID.PROJECT,
            key: ModelTypeID.PROJECT,
            message: t('modelType.project'),
            class: 'iconfont icon-xiangmuzhinengti1',
            type: ModelType.PROJECT
        },
        {
            id: ModelTypeID.PARTNER,
            key: ModelTypeID.PARTNER,
            message: t('modelType.partner'),
            type: ModelType.PARTNER,
            class: 'iconfont icon-zhinengxueban',
            authCheck: true
        }
    ];
    const [clickCurrentModel, setClickCurrentModel] = useState<ModelType | null>(ModelType.COMMON);
    // ==================== Runtime ====================
    const [agent] = useXAgent<{ data: string }>({
        baseURL: baseUrl + '/chat'
    });
    const [enaeaAgent] = useXAgent<{ data: string }>({
        baseURL: baseUrl + '/buddy'
    });
    const confirmHandle = (title: ReactNode, content: ReactNode, onOk: () => void) => {
        confirm({
            getContainer: () => document.querySelector('.enaea_layout') as HTMLElement,
            wrapClassName: 'delete-modal',
            title,
            centered: true,
            icon: null,
            content,
            okText: '确认',
            cancelText: '取消',
            autoFocusButton: null,
            onOk
        });
    };

    const { messages, setMessages } = useXChat({
        agent
    });
    useEffect(() => {
        setPrompts(null);
    }, []);
    const parseChatJson = (conversationsItem: typeof defaultConversationsItem, message: string, type: AbilityTypeId, query?: string) => {
        if (!message) return '';
        try {
            const json = parse(message, Allow.ALL);
            if (json && json.content) {
                const items: PromptsProps['items'] = [];
                if (json.list && json.list.length) {
                    for (const ele of json.list) {
                        if (ele && ele.title) {
                            items.push({
                                id: ele.id || '',
                                key: String(ele.title),
                                description: _.unescape(ele.title),
                                detail_url: ele.detail_url,
                                image_url: ele.image_url,
                                content: ele.introduction
                            });
                        }
                    }
                }
                if (type === AbilityTypeId.PARTNER_PROJECT) {
                    const newList: PromptsProps['items'] = [];
                    items.forEach((item) => {
                        newList.push({ key: item.key, id: item.id, label: '', description: item.description });
                    });
                    return (
                        <div className={'resource-course'}>
                            <span className={'resource-message-title'}>{json?.content}</span>
                            <Space direction="vertical" size={16}>
                                <Prompts
                                    className={'welcome-prompts'}
                                    style={{ margin: '15px 0 0 0' }}
                                    title={''}
                                    items={newList}
                                    styles={{
                                        list: {
                                            width: '100%',
                                            flexDirection: 'column'
                                        },
                                        item: {
                                            flex: 1
                                        }
                                    }}
                                    onItemClick={(info) => {
                                        const data = info.data || {};
                                        if (json.format && json.format === 'resource_selection') {
                                            const len = messages.length;
                                            const currKey = 'msg_' + activeKey + len;
                                            const nextId = 'msg_' + activeKey + (len + 1);
                                            setIsFirst(false);
                                            setClickCurrentModel(null);
                                            const newMessages = [
                                                ...messages,
                                                {
                                                    //@ts-ignore
                                                    role: 'local',
                                                    //@ts-ignore
                                                    status: 'complete',
                                                    id: currKey,
                                                    //@ts-ignore
                                                    message: data.description,
                                                    type: prompts?.id || '',
                                                    conversation_key: currentConversation.key
                                                },
                                                {
                                                    //@ts-ignore
                                                    role: 'ai',
                                                    //@ts-ignore
                                                    status: 'loading',
                                                    id: nextId,
                                                    //@ts-ignore
                                                    message: '',
                                                    type: prompts?.id || '',
                                                    conversation_key: currentConversation.key
                                                }
                                            ];
                                            //@ts-ignore
                                            setMessages(newMessages);
                                            setCurrentMsg({
                                                message: '',
                                                status: '',
                                                id: '',
                                                message_id: '',
                                                conversation_id: '',
                                                type: prompts?.id || '',
                                                conversation_key: currentConversation.key
                                            });
                                            setLoading(true);
                                            //@ts-ignore
                                            const queryStr = query ? query : (messages[len - 1].message as string);
                                            createRequest(queryStr, nextId, data.id);
                                        }
                                    }}
                                />
                            </Space>
                        </div>
                    );
                }
                if (type === AbilityTypeId.RESOURCE_EXPERT) {
                    return (
                        <div className={'resource-experts'}>
                            <span className={'resource-message-title'}>{json?.content}</span>
                            <div className={'resource-experts-list'}>
                                {items?.map((item) => {
                                    let imgUrl = DefaultExpert;
                                    const PICTURE_EXPRESSION = /\.(png|jpe?g|gif|svg)(\?.*)?$/;
                                    const picReg = new RegExp(PICTURE_EXPRESSION);
                                    if (picReg.test(item.image_url as string)) {
                                        imgUrl = item.image_url as string;
                                    }
                                    return (
                                        <div
                                            className={'resource-experts-item'}
                                            onClick={() => {
                                                if (item.detail_url) window.open(item.detail_url);
                                            }}
                                        >
                                            <img src={imgUrl} alt={item.description as string} />
                                            <span>{item.description}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                } else if (type === AbilityTypeId.RESOURCE_CASE || type === AbilityTypeId.RESOURCE_DIGITAL_RESOURCE) {
                    const newList: PromptsProps['items'] = [];
                    items.forEach((item) => {
                        newList.push({ key: item.key, label: item.description, description: item.detail_url });
                    });
                    return (
                        <Prompts
                            wrap
                            items={newList}
                            onItemClick={(info) => {
                                const data = info.data || {};
                                if (data.description) {
                                    if (data.description) window.open(data.description as string);
                                }
                            }}
                            styles={
                                items.length > 1
                                    ? {
                                          item: {
                                              flex: 'none',
                                              width: 'calc(50% - 6px)'
                                          }
                                      }
                                    : {}
                            }
                            title={<span className={'resource-message-title'}>{json?.content}</span>}
                        />
                    );
                } else if (type === AbilityTypeId.RESOURCE_COURSE) {
                    return (
                        <div className={'resource-course'}>
                            <span className={'resource-message-title'}>{json?.content}</span>
                            <div className={'resource-course-list'}>
                                {items?.map((item) => {
                                    let imgUrl = DefaultSource;
                                    const PICTURE_EXPRESSION = /\.(png|jpe?g|gif|svg)(\?.*)?$/;
                                    const picReg = new RegExp(PICTURE_EXPRESSION);
                                    if (picReg.test(item.image_url as string)) {
                                        imgUrl = item.image_url as string;
                                    }
                                    return (
                                        <div
                                            key={item.detail_url}
                                            className={'resource-course-item'}
                                            onClick={() => {
                                                if (item.detail_url) window.open(item.detail_url);
                                            }}
                                        >
                                            <img src={imgUrl} alt={item.description as string} />
                                            <span>{item.description}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                } else if (conversationsItem.type === ModelType.PROJECT) {
                    const newItems: CollapseProps['items'] = [];
                    items.forEach((item, index) => {
                        const tmp = {
                            key: String(index),
                            label: (
                                <span
                                    style={{
                                        fontWeight: 400,
                                        fontSize: 16,
                                        color: '#333333',
                                        maxWidth: '596px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: 'inline-block',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {item.description}
                                </span>
                            ),
                            children: (
                                <Typography>
                                    <div dangerouslySetInnerHTML={{ __html: md.render(item.content || '') }} />
                                </Typography>
                            ),
                            style: {
                                marginBottom: 14,
                                background: '#fff',
                                borderRadius: 8,
                                border: 'none'
                            }
                        };
                        newItems.push(tmp);
                    });
                    return (
                        <div className={'resource-course'}>
                            <span className={'resource-message-title'}>{json?.content}</span>
                            <Collapse
                                className={'resource-message-project'}
                                bordered={false}
                                expandIconPosition={'end'}
                                defaultActiveKey={[]}
                                expandIcon={({ isActive }) => (
                                    <span
                                        style={{
                                            fontWeight: 400,
                                            fontSize: 16,
                                            color: '#E2241D'
                                        }}
                                    >
                                        {isActive ? '收起' : '展开'}
                                        <RightOutlined rotate={isActive ? 90 : 0} />
                                    </span>
                                )}
                                style={{ background: 'transparent', width: 690 }}
                                items={newItems}
                            />
                        </div>
                    );
                }
            }
            return message;
        } catch (e) {
            console.error(e);
            return message;
        }
    };

    const saveAndUpdateConversation = (messages: any[]) => {
        const newConversationsItems = cloneDeep(conversationsItems);
        if (!isFirst && !newConversationsItems.find((item: any) => item.key === currentConversation.key)) {
            currentConversation.label = messages[0].message;
            newConversationsItems.unshift(currentConversation);
        }
        let flag = false;
        for (const item of newConversationsItems) {
            if (item.key === activeKey) {
                const cloneItem = cloneDeep(item);
                item.message = messages;
                cloneItem.message = messages.map(({ id, message, status, role, message_id, conversation_id, type, query, auth }, index) => ({
                    key: id,
                    loading: status === 'loading',
                    role: role === 'local' ? 'local' : 'ai',
                    content: message,
                    message_id: message_id,
                    id: message_id,
                    conversation_id: conversation_id,
                    footer:
                        role === 'local' ? null : status === 'complete' && auth !== 'none' ? (
                            <div
                                className={'re-sync'}
                                onClick={() => {
                                    if (messages[index - 1] && messages[index - 1].id) {
                                        setLoading(true);
                                        setCurrentMsg({
                                            message: '',
                                            status: '',
                                            id: '',
                                            message_id: '',
                                            conversation_id: '',
                                            conversation_key: '',
                                            type: ''
                                        });
                                        setClickCurrentModel(null);
                                        createRequest(query || (messages[index - 1].message as string), id, '', type);
                                        return Toast.info(t('success'));
                                    }
                                    return Toast.info(t('fail'));
                                }}
                            >
                                <SyncOutlined style={{ cursor: 'pointer' }} />
                                <span>{t('generation')}</span>
                            </div>
                        ) : null,
                    messageRender: (message: string) => {
                        if (auth === 'none') {
                            return (
                                <Prompts
                                    className={'no-auth-message'}
                                    title={`您可以输入“${URL.login}”并点击左下角的【登录按钮】`}
                                    items={[]}
                                    vertical
                                />
                            );
                        }
                        if (item.typeId === ModelTypeID.COMMON && role !== 'local') {
                            return <Markdown content={message} />;
                        } else if (role !== 'local') {
                            return parseChatJson(item, message, type, query);
                        }
                        return message;
                    }
                }));
                flag = true;
                setCurrentConversation(cloneItem);
                break;
            }
        }
        if (flag) {
            localStorage.setItem('conversation-list', JSON.stringify(newConversationsItems));
            setConversationsItems(newConversationsItems);
        }
    };
    useEffect(() => {
        if (messages && currentConversation && activeKey) {
            saveAndUpdateConversation(messages);
        }
    }, [messages]);
    const updateChatStatus = (id: string, resultMsg: string, state: string, message_id: string, conversation_id: string) => {
        const cloneMessages = cloneDeep(messages);
        const { status, result } = getValueByProp('id', id, cloneMessages);
        if (status) {
            result.message = resultMsg;
            result.message_id = message_id;
            result.conversation_id = conversation_id;
            result.status = state;
            setMessages(cloneMessages);
        }
    };
    useEffect(() => {
        if (currentMsg.message) {
            updateChatStatus(currentMsg.id, currentMsg.message, currentMsg.status, currentMsg.message_id, currentMsg.conversation_id);
            //@ts-ignore
            if (currentMsg.conversation_key) {
                let flag = false;
                const cloneConversationsItems = cloneDeep(conversationsItems);
                for (const item of cloneConversationsItems) {
                    //@ts-ignore
                    if (item.key === currentMsg.conversation_key) {
                        if (currentMsg.conversation_id) {
                            item.conversation_id = currentMsg.conversation_id;
                            item.id = currentMsg.conversation_id;
                            flag = true;
                        } else {
                            item.conversation_id = '';
                            item.id = '';
                        }
                        break;
                    }
                }
                if (flag) setConversationsItems(cloneConversationsItems);
            }
        }
    }, [currentMsg]);
    const createRequest = (msg: string, nextId: string, sourceId?: string, toolId?: string) => {
        let messageResult = '',
            agent_id = currentConversation?.typeId,
            tool_id = toolId || prompts?.id || '',
            conversation_id = currentConversation?.conversation_id || '',
            deep_think = currentConversation?.type === ModelType.COMMON && modelType === 1,
            web_search = currentConversation?.type === ModelType.COMMON && onlineSearch === '1',
            conversation_key = currentConversation.key;
        const body: ChatRequestBody = {
            query: msg,
            agent_id,
            tool_id,
            user_id: userInfo.username || '',
            conversation_id,
            stream: true,
            deep_think,
            web_search
        };
        if (currentConversation.type !== ModelType.COMMON) {
            delete body.deep_think;
            delete body.web_search;
            //@ts-ignore
        }
        let request = agent;
        if (currentConversation.type === ModelType.PARTNER) {
            //@ts-ignore
            if (sourceId) body.id = sourceId;
            request = enaeaAgent;
        }
        request.request(body, {
            onSuccess: () => {
                setLoading(false);
            },
            onUpdate: (message) => {
                if (message.data) {
                    const data: ChatResp = JSON.parse(message.data);
                    if (data.conversation_id && !currentMsg.conversation_id) {
                        setCurrentMsg((prevState) => {
                            if (!currentMsg.conversation_key) currentMsg.conversation_key = conversation_key;
                            prevState.conversation_id = data.conversation_id;
                            return prevState;
                        });
                    }
                    if (data.conversation_id && !currentConversation.conversation_id) {
                        setCurrentConversation((prevState) => {
                            prevState.conversation_id = data.conversation_id;
                            prevState.id = data.conversation_id;
                            return prevState;
                        });
                    }
                    if (data.event === EventType.MESSAGE) {
                        //@ts-ignore
                        const isString = typeof data.answer === 'string';
                        //@ts-ignore
                        if (!isString && typeof data.answer === 'object' && typeof data.answer?.content === 'string') {
                            //@ts-ignore
                            messageResult = data.answer?.content;
                        } else {
                            messageResult += data.answer;
                        }
                        setCurrentMsg({
                            id: nextId,
                            message: messageResult,
                            status: 'complete',
                            message_id: data.message_id,
                            conversation_id: data.conversation_id,
                            //@ts-ignore
                            conversation_key,
                            type: tool_id
                        });
                    } else if (data.event === EventType.MESSAGE_END) {
                        setCurrentMsg({
                            id: nextId,
                            message_id: data.message_id,
                            conversation_id: data.conversation_id,
                            message: messageResult,
                            //@ts-ignore
                            conversation_key,
                            status: 'complete',
                            type: tool_id
                        });
                    }
                    console.log(messageResult, 'messageResultmessageResult');
                    //@ts-ignore
                } else if (message.hasOwnProperty('success') && !message.success) {
                    setLoading(false);
                    setCurrentMsg({
                        id: nextId,
                        message_id: '',
                        conversation_id: '',
                        //@ts-ignore
                        message: message.msg || t('fail'),
                        //@ts-ignore
                        conversation_key,
                        status: 'complete',
                        type: tool_id
                    });
                }
            },
            onError: (error) => {
                console.error(error);
                setCurrentMsg({
                    id: nextId,
                    message_id: '',
                    conversation_id: '',
                    //@ts-ignore
                    conversation_key,
                    //@ts-ignore
                    message: error.msg || t('fail'),
                    status: 'error',
                    type: tool_id
                });
                setLoading(false);
            }
        });
    };

    // ==================== Event ====================
    const onSubmit = (nextContent: string) => {
        if (!nextContent) return;
        setIsFirst(false);
        const len = messages.length;
        if (currentConversation && currentConversation.type === ModelType.PARTNER && userInfo.username === 'GUEST') {
            const newMessages = [
                ...messages,
                {
                    //@ts-ignore
                    role: 'local',
                    //@ts-ignore
                    status: 'complete',
                    id: 'msg_' + activeKey + len,
                    //@ts-ignore
                    message: nextContent,
                    conversation_key: currentConversation.key
                },
                {
                    //@ts-ignore
                    role: 'ai',
                    //@ts-ignore
                    status: '',
                    id: 'msg_' + activeKey + (len + 1),
                    query: nextContent,
                    auth: 'none',
                    //@ts-ignore
                    message: '',
                    conversation_key: currentConversation.key
                }
            ];
            //@ts-ignore
            setMessages(newMessages);
            setContent('');
        } else {
            const nextId = 'msg_' + activeKey + (len + 1);
            const newMessages = [
                ...messages,
                {
                    //@ts-ignore
                    role: 'local',
                    //@ts-ignore
                    status: 'complete',
                    id: 'msg_' + activeKey + len,
                    //@ts-ignore
                    message: nextContent,
                    type: prompts?.id || '',
                    conversation_key: currentConversation.key
                },
                {
                    //@ts-ignore
                    role: 'ai',
                    //@ts-ignore
                    status: 'loading',
                    id: nextId,
                    //@ts-ignore
                    message: '',
                    query: nextContent,
                    conversation_key: currentConversation.key,
                    type: prompts?.id || ''
                }
            ];
            //@ts-ignore
            setMessages(newMessages);
            if (currentConversation.message && !currentConversation.message.length) {
                const newCurrentConversation: typeof defaultConversationsItem = cloneDeep(currentConversation);
                //@ts-ignore
                newCurrentConversation.message = newMessages;
                setCurrentConversation(newCurrentConversation);
                setActiveKey(currentConversation.key);
            }
            setLoading(true);
            setCurrentMsg({
                message: '',
                status: '',
                id: '',
                message_id: '',
                conversation_id: '',
                type: prompts?.id || '',
                conversation_key: ''
            });
            setClickCurrentModel(null);
            createRequest(nextContent, nextId);
            setContent('');
        }
    };

    const onWelcomePromptsItemClick: GetProp<typeof Prompts, 'onItemClick'> = (info) => {
        const len = messages.length;
        const nextId = 'msg_' + activeKey + (len + 1);
        setIsFirst(false);
        setClickCurrentModel(null);
        const newMessages = [
            ...messages,
            {
                //@ts-ignore
                role: 'local',
                //@ts-ignore
                status: 'complete',
                id: 'msg_' + activeKey + len,
                //@ts-ignore
                message: info.data.description,
                type: prompts?.id || '',
                conversation_key: currentConversation.key
            },
            {
                //@ts-ignore
                role: 'ai',
                //@ts-ignore
                status: 'loading',
                id: nextId,
                //@ts-ignore
                message: '',
                type: prompts?.id || '',
                query: info.data.description,
                conversation_key: currentConversation.key
            }
        ];
        //@ts-ignore
        setMessages(newMessages);
        setCurrentMsg({
            message: '',
            status: '',
            id: '',
            message_id: '',
            conversation_id: '',
            type: prompts?.id || '',
            conversation_key: currentConversation.key
        });
        setLoading(true);
        createRequest(info.data.description as string, nextId);
    };
    const onPromptsItemClick: GetProp<typeof Prompts, 'onItemClick'> = (info) => {
        //@ts-ignore
        if (info.data?.id === prompts?.id) return;
        //@ts-ignore
        setPrompts({ id: info.data.id as string, message: info.data.description as string });
    };
    const promptsItems: any = {
        [ModelType.RESOURCE]: [
            {
                key: AbilityTypeId.RESOURCE_COURSE,
                id: AbilityTypeId.RESOURCE_COURSE,
                label: t('abilityType.resourceCourse'),
                icon: null
            },
            {
                key: AbilityTypeId.RESOURCE_CASE,
                id: AbilityTypeId.RESOURCE_CASE,
                label: t('abilityType.resourceCase'),
                icon: null
            },
            {
                key: AbilityTypeId.RESOURCE_DIGITAL_RESOURCE,
                id: AbilityTypeId.RESOURCE_DIGITAL_RESOURCE,
                label: t('abilityType.resourceDigitalResource'),
                icon: null
            },
            {
                key: AbilityTypeId.RESOURCE_EXPERT,
                id: AbilityTypeId.RESOURCE_EXPERT,
                label: t('abilityType.resourceExpert'),
                icon: null
            }
        ],
        [ModelType.PARTNER]: [
            // {
            //     key: AbilityTypeId.PARTNER_PERSONAL_TRAINING,
            //     id: AbilityTypeId.PARTNER_PERSONAL_TRAINING,
            //     label: t('abilityType.partnerPersonalTraining'),
            //     icon: null,
            // },
            {
                key: AbilityTypeId.PARTNER_PROJECT,
                id: AbilityTypeId.PARTNER_PROJECT,
                label: t('abilityType.partnerProject'),
                icon: null
            }
            // {
            //     key: AbilityTypeId.PARTNER_COURSE,
            //     id: AbilityTypeId.PARTNER_COURSE,
            //     label: t('abilityType.partnerCourse'),
            //     icon: null,
            // },
            // {
            //     key: AbilityTypeId.PARTNER_JOB,
            //     id: AbilityTypeId.PARTNER_JOB,
            //     label: t('abilityType.partnerJob'),
            //     icon: null,
            // },
        ],
        [ModelType.PROJECT]: [],
        [ModelType.ASSISTANT]: []
    };
    const getPromptsItems = (type: ModelType) => {
        const list = promptsItems.hasOwnProperty(type) ? promptsItems[type] : [];
        if (list.length) {
            const tmp = {
                id: list[0].id as string,
                key: list[0].id,
                label: list[0].description as string,
                message: list[0].description as string
            };
            setPrompts(tmp);
        } else {
            setPrompts(null);
        }
        return list;
    };

    const onAddConversation = (type: ModelType, item: ModelItemType) => {
        setIsFirst(true);
        if (type !== ModelType.COMMON) {
            setModelType(1);
            setOnlineSearch('');
        }
        setClickCurrentModel(type);
        const message: any[] = [];
        const newCurr: typeof defaultConversationsItem = {
            key: `${Math.floor(Math.random() * 1024)}`,
            id: `${conversationsItems.length}`,
            label: `${t('newConversation')} ${conversationsItems.length > 0 ? conversationsItems.length : ''}`,
            type,
            //@ts-ignore
            typeId: item.id,
            senderPromptsItems: getPromptsItems(type as ModelType),
            // @ts-ignore
            message
        };
        setMessages([]);
        setActiveKey(newCurr.key);
        setCurrentConversation(newCurr);
    };

    const onConversationClick: GetProp<typeof Conversations, 'onActiveChange'> = (key) => {
        setActiveKey(key);
        setClickCurrentModel(null);
        let index = 0,
            flag = false;
        for (const keyElement of conversationsItems) {
            if (keyElement.key === key) {
                flag = true;
                break;
            }
            index++;
        }
        if (flag) {
            setActiveKey(conversationsItems[index].key || '');
            setCurrentConversation(conversationsItems[index]);
            if (conversationsItems[index] && conversationsItems[index].message) {
                setMessages(conversationsItems[index].message);
            }
            if (conversationsItems[index] && conversationsItems[index].senderPromptsItems?.length) {
                const list = conversationsItems[index].senderPromptsItems;
                if (list.length) {
                    const tmp = {
                        id: list[0].id as string,
                        key: list[0].id,
                        label: list[0].description as string,
                        message: list[0].description as string
                    };
                    setPrompts(tmp);
                } else {
                    setPrompts(null);
                }
            }
        }
    };

    const welcomeNode = useMemo(() => {
        return (
            <Space direction="vertical" size={16} className={'chats-placeholder'}>
                <Welcome
                    variant="borderless"
                    icon={null}
                    title={''}
                    description={
                        <span className={'welcome-desc'}>
                            {currentConversation?.type === ModelType.PARTNER && userInfo?.success && userInfo.username === 'GUEST'
                                ? description[ModelType.NO_AUTH]
                                : description[currentConversation?.type]}
                        </span>
                    }
                    extra={null}
                />
                {currentConversation?.type === ModelType.PARTNER &&
                userInfo?.success &&
                userInfo.username === 'GUEST' ? null : placeholderPromptsItems[prompts?.id as string] ||
                  placeholderPromptsItems[currentConversation?.type] ? (
                    <Prompts
                        className={'welcome-prompts'}
                        title={''}
                        items={placeholderPromptsItems[prompts?.id as string] || placeholderPromptsItems[currentConversation?.type]}
                        styles={{
                            list: {
                                width: '100%'
                            },
                            item: {
                                flex: 1
                            }
                        }}
                        onItemClick={onWelcomePromptsItemClick}
                    />
                ) : null}
            </Space>
        );
    }, [currentConversation?.type, prompts?.id]);

    // ==================== Nodes ====================
    const chooseModel = useMemo(
        () => (
            <div className={'choose-model'}>
                {modelList.map((item) => (
                    <div
                        key={item.key}
                        onClick={() => onAddConversation(item.type, item)}
                        className={'choose-model-item' + (clickCurrentModel === item.type ? ' active' : '')}
                    >
                        <i className={'model-icon ' + item.class}></i>
                        <span className={'title'}>{item.message}</span>
                    </div>
                ))}
            </div>
        ),
        [modelList, clickCurrentModel]
    );

    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    const senderFooter = useMemo(() => {
        if (currentConversation.type === ModelType.COMMON) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                    <Select
                        value={modelType}
                        optionRender={(option) => (
                            <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                                {option.data.label}
                                {option.data.value === modelType ? (
                                    <span role="img" style={{ color: '#E2241D' }} aria-label={option.data.label}>
                                        <CheckCircleOutlined />
                                    </span>
                                ) : null}
                            </Space>
                        )}
                        style={{ width: 130 }}
                        onChange={(value) => setModelType(value)}
                        options={[
                            { label: 'DeepSeek', value: 1 },
                            { label: '通义千问', value: 2 }
                        ]}
                    />
                    <Radio.Group value={onlineSearch}>
                        <Radio.Button
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                let value = '';
                                //@ts-ignore
                                if (e.target.checked && onlineSearch === '1') {
                                    value = '';
                                } else {
                                    //@ts-ignore
                                    value = e.target.value;
                                }
                                setOnlineSearch(value);
                            }}
                            value="1"
                            className={'online-search'}
                        >
                            <GlobalOutlined style={{ margin: '0 4px 0 0' }} />
                            {t('onlineSearch')}
                        </Radio.Button>
                    </Radio.Group>
                </div>
            );
        }
        return null;
    }, [currentConversation.type, modelType, onlineSearch]);
    const deleteConversationHandle = (conversation: typeof defaultConversationsItem) => {
        const callback = () => {
            let cloneList = cloneDeep(conversationsItems);
            let i = 0,
                flag = false;
            for (const item of cloneList) {
                if (item.id === conversation.id) {
                    flag = true;
                    break;
                }
                i++;
            }
            if (flag) {
                cloneList.splice(i, 1);
                setConversationsItems(cloneList);
                const cloneDefault = cloneDeep(defaultConversationsItem);
                setCurrentConversation(cloneDefault);
                setClickCurrentModel(cloneDefault.type);
                setActiveKey('');
                setMessages([]);
                localStorage.setItem('conversation-list', JSON.stringify(cloneList));
                //@ts-ignore
                Toast.info(t('success'));
            }
        };
        confirmHandle('删除对话记录', '此操作将永久删除您创建的所有聊天记录，且无法撤销。' + '请确认以继续。', callback);
    };
    const usePlaceholder = useMemo(() => {
        const defaultPlaceholder: any = {
            [ModelType.COMMON]: '您好！我是您的AI助手，请问需要什么帮助？',
            [AbilityTypeId.RESOURCE_COURSE]: '例：请帮我推荐"中小学干部"的培训课程。',
            [AbilityTypeId.RESOURCE_CASE]: '例："职业教育"领域都有哪些经典案例？',
            [AbilityTypeId.RESOURCE_DIGITAL_RESOURCE]: '例：请帮我推荐关于”人工智能“的相关资源？',
            [AbilityTypeId.RESOURCE_EXPERT]: '例："高等教育"领域都有哪些专家？',
            [ModelType.PARTNER]: '请输入正确的项目名称进行问答，例如《您所参加项目的完整项目名称》的总学进度是多少？',
            [ModelType.ASSISTANT]: '请输入您在使用过程中的问题描述，例如忘记登录密码怎么办？',
            [ModelType.PROJECT]: '例：“基础教育“教师培训都有哪些重点项目？'
        };
        return defaultPlaceholder[prompts?.id as string] || defaultPlaceholder[currentConversation?.type] || '';
    }, [currentConversation?.type, prompts?.id]);
    const userPrompts = useMemo(() => {
        return currentConversation?.senderPromptsItems.map((item: any) => (
            <span
                className={'sender-prompts-item ' + (prompts?.id === item.id ? 'active' : '')}
                key={item.key || item.id}
                onClick={() => onPromptsItemClick({ data: item })}
            >
                {item.label}
            </span>
        ));
    }, [currentConversation?.senderPromptsItems, prompts?.id]);

    // ==================== Render =================
    return (
        <div className={'chats-layout'}>
            <div className={'chats-menu'}>
                {/* 🌟 logo */}
                <div className={'chats-logo'}>
                    <img src={AIAvatar} draggable={false} alt={'ai'} />
                    <img src={AILogo} draggable={false} alt="logo" />
                    <span>{t('name')}</span>
                </div>
                {/* 🌟 模型选择 */}
                {chooseModel}
                {/* 🌟 会话管理 */}
                <div className={'recent-conversations'}>
                    <span className={'title'}>{t('recentConversations')}</span>
                    <Conversations
                        items={conversationsItems}
                        className={'chats-conversations'}
                        activeKey={activeKey}
                        onActiveChange={onConversationClick}
                        menu={(conversation) => {
                            return {
                                trigger: () => (
                                    <div className={'conversation-item-op'}>
                                        <i
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                deleteConversationHandle(conversation as typeof defaultConversationsItem);
                                            }}
                                            className={'iconfont icon-agent-delete conversation-item-delete'}
                                        />
                                    </div>
                                ),
                                items: []
                            };
                        }}
                    />
                </div>
                <div className={'login-user-info'}>
                    <div className={'user-info'}>
                        <img src={Avatar} alt={''} />
                        <Dropdown
                            menu={
                                userInfo?.success && userInfo.username === 'GUEST'
                                    ? ({
                                          items: [
                                              {
                                                  key: '1',
                                                  label: t('login')
                                              }
                                          ],
                                          onClick: () => {
                                              window.location.href = URL.login + encodeURIComponent(window.location.href);
                                          }
                                      } as MenuProps)
                                    : ({
                                          items: [
                                              {
                                                  key: '2',
                                                  label: t('logout')
                                              }
                                          ],
                                          onClick: () => {
                                              window.location.href = URL.logout;
                                          }
                                      } as MenuProps)
                            }
                        >
                            <span className={'user-name'}>
                                {userInfo?.success && userInfo.username === 'GUEST' ? userInfo.username : userInfo.screenName}{' '}
                            </span>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div className={'chats-chat'}>
                {/* 🌟 消息列表 */}
                <Bubble.List
                    key={currentConversation.conversation_id}
                    items={
                        currentConversation?.message?.length > 0
                            ? currentConversation?.message
                            : [
                                  {
                                      content: welcomeNode,
                                      variant: 'borderless',
                                      avatar: { icon: CatAIIcon }
                                  }
                              ]
                    }
                    roles={roles}
                    className={'chats-messages'}
                />
                {/* 🌟 提示词 */}
                <div className={'sender-prompts-items'}>{userPrompts}</div>
                {/* 🌟 输入框 */}
                <Sender
                    placeholder={usePlaceholder}
                    value={content}
                    footer={senderFooter}
                    onSubmit={onSubmit}
                    onChange={setContent}
                    loading={loading}
                    className={'chats-sender'}
                />
            </div>
        </div>
    );
};

const Chart = () => (
    <AuthCheck>
        <Chats />
    </AuthCheck>
);
export default Chart;
